<!-- 关于品牌 -->
<template>
    <div class='head_boxs'>
        <carousel :list="webDate.aboutBrandTop" height="400px" v-if="webDate"></carousel>
        <carousel :list="webDate.aboutBrandBanner" :fullScreen="true" v-if="webDate"></carousel>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex'
import carousel from '@/components/carousel.vue'
const store = useStore()
const webDate = computed(() => store.state.webDate);
</script>

<style scoped lang='scss'>
.head_boxs {
    width: 100%;
    padding-top: 87px;
    width: 100%;
}
</style>
